// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__3OqkO","About__Text":"About_About__Text__1hg0D","About__Title":"About_About__Title__2T5iM"};